import MUIDeleteForever from '@mui/icons-material/DeleteForever'

export const DeleteForever = MUIDeleteForever
